const SITE_URL = 'https://justgologistics.com';
function setMeta(property, value, attribute = 'name') {
  let element = document.head.querySelector(`meta[${attribute}="${property}"]`);
  if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, property); document.head.appendChild(element); }
  element.setAttribute('content', value);
}
export function setPageMeta({ title, description, path = '/' }) {
  const canonicalUrl = `${SITE_URL}${path === '/' ? '/' : path}`;
  document.title = title;
  setMeta('description', description);
  setMeta('og:title', title, 'property');
  setMeta('og:description', description, 'property');
  setMeta('og:type', 'website', 'property');
  setMeta('og:url', canonicalUrl, 'property');
  setMeta('twitter:card', 'summary');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
  canonical.setAttribute('href', canonicalUrl);
}

export function setStructuredData(id, data) {
  let script = document.head.querySelector(`script[data-seo-schema="${id}"]`);
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.seoSchema = id;
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export const businessSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#business`,
  name: 'Just Go Logistics LLC',
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/assets/GOGO.png`,
  image: `${SITE_URL}/assets/images/same-day-urgent-delivery.jpg`,
  telephone: '+1-866-424-5878',
  email: 'sales@justgologistics.com',
  priceRange: '$$',
  description: 'Commercial courier, final mile, medical courier, scheduled route, same day, hot shot, and warehouse delivery coordination.',
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Maricopa County, Arizona' },
    { '@type': 'City', name: 'Tucson, Arizona' },
    { '@type': 'City', name: 'Phoenix, Arizona' },
    { '@type': 'AdministrativeArea', name: 'Harris County, Texas' },
    { '@type': 'City', name: 'Houston, Texas' },
    { '@type': 'City', name: 'Katy, Texas' },
    { '@type': 'City', name: 'Dallas, Texas' },
    { '@type': 'City', name: 'Brooklyn Park, Minnesota' },
    { '@type': 'City', name: 'Philadelphia, Pennsylvania' },
  ],
  sameAs: [
    'https://www.linkedin.com/in/just-go-logistics-llc-322726337/',
    'https://www.facebook.com/profile.php?id=100094785966312',
  ],
};
